module.exports = __webpack_public_path__ + "static/media/1020979.d7711eb2.png";